import { useCallback, useLayoutEffect, useRef, useState } from "react";
import Loader from "@components/global/Loader/Loader";
import useApiRequests from "@services/http/useApiRequest";
import { useDispatch } from "react-redux";
import { IRequestGetterProps } from "./RequestGetter.props";
import { BaseResponse } from "@services/http/responses/BaseResponse";
import { dev } from "@utils/dev";

interface GetterResponse extends BaseResponse {
  readonly [key: string | "Record" | "Records"]: any;
  readonly Total: number;
}

export default function RequestGetter({
  deps = [],
  ...props
}: IRequestGetterProps) {
  const { request, hasPagination, action } = props;
  const maxTotal = useRef<number>();
  const maxRecords = useRef<number>(0);
  const dispatch = useDispatch();
  const { enqueue } = useApiRequests();
  const [loading, setLoading] = useState<boolean>(true);

  const serverRequest = useCallback(async () => {
    if (
      hasPagination &&
      maxTotal.current &&
      maxTotal.current === maxRecords.current
    ) {
      dev.log("Max current items has occured!");
      return;
    }
    const res = await enqueue<GetterResponse>(request, {
      onLoadingStatusChanged: setLoading,
    });
    if (!res) return;
    if ("Record" in res) {
      if (!props.onData) dispatch(action(res.Record));
    } else {
      maxTotal.current = res.Total;
      maxRecords.current = maxRecords.current + res.Records.length;
      if (!props.onData) dispatch(action(res.Records));
    }

    if (props.onData) props.onData(res);
  }, deps);

  useLayoutEffect(() => {
    serverRequest();
  }, deps);

  return loading ? <Loader size={props.size} style={{ zIndex: 10 }} /> : null;
}
